export const BLOG_POST_FILES_RESET_STATE = 'BLOG_POST_FILES_RESET_STATE';
export const BLOG_POST_FILES_CURRENT_ITEM = 'BLOG_POST_FILES_CURRENT_ITEM';

export const BLOG_POST_FILES_REQUEST_LOADING = 'BLOG_POST_FILES_REQUEST_LOADING';
export const BLOG_POST_FILES_REQUEST_SUCCESS = 'BLOG_POST_FILES_REQUEST_SUCCESS';
export const BLOG_POST_FILES_REQUEST_FAILED = 'BLOG_POST_FILES_REQUEST_FAILED';

export const BLOG_POST_FILES_CURRENT_ACTION = 'BLOG_POST_FILES_CURRENT_ACTION';
export const BLOG_POST_FILES_RESET_ACTION = 'BLOG_POST_FILES_RESET_ACTION';